import { __ } from '@wordpress/i18n';
import { PanelBody, SelectControl, ToggleControl } from "@wordpress/components";
import Controls from './Carousel/Controls';
import { caroDirectionOpt } from '../../../../utils/options';
import Notice from '../../Notice';
import { BControlPro } from '../../../../../../bpl-tools/ProControls';

const ThumbnailsGeneral = ({ attributes, updateObject, premiumProps }) => {
    const { carousel, arrow } = attributes
    const { caroDirection } = carousel;

    const controlsProps = {
        attributes,
        updateObject,
        premiumProps
    }
    return <PanelBody className='bPlPanelBody' title={__('Thumbnails', 'slider')} initialOpen={false}>
        <Notice />
        <Controls {...controlsProps} />

        <BControlPro className='mt10' label={__('Direction', "slider")} value={caroDirection} options={caroDirectionOpt} onChange={val => updateObject("carousel", "caroDirection", val)} Component={SelectControl} {...premiumProps} />

        <BControlPro className='mt20' label={__('Show Arrow/Navigation', 'slider')} checked={arrow.visibility} onChange={(value) => { updateObject('arrow', 'visibility', value) }} Component={ToggleControl} {...premiumProps} />
    </PanelBody>
}
export default ThumbnailsGeneral;